import { Drawer, DrawerProps } from 'components/Drawer/DrawerDeprecated';
import { Text } from 'components/Text/Text';

import { AddTrackableListForm } from './AddTrackableListForm';

export type AddTrackableListDialogProps = DrawerProps & {
  onSuccess?: () => void;
};

export function AddTrackableListDialog({
  open,
  onClose,
  onSuccess,
}: AddTrackableListDialogProps) {
  return (
    <Drawer title="Create trackable list" open={open} onClose={onClose}>
      <Text type="paragraph">
        Create a trackable list to organize and manage objects for tracking in
        video streams.
      </Text>

      <AddTrackableListForm
        onSuccess={() => {
          onClose?.();
          onSuccess?.();
        }}
      />
    </Drawer>
  );
}
